import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  comment: {},
  comments: []
}

const mutations = {
  SET_COMMENT (state, payload) {
    state.comment = payload
  },
  SET_COMMENTS (state, payload) {
    state.comments = payload
  },
  ADD_COMMENTS (state, payload) {
    state.comments.docs.unshift(payload)
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  createCommentPlanCon: (context, data) => {
    return Vue.http.post(`${env.API}/api/comments-plancon`, data)
      .then((response) => {
        context.commit('ADD_COMMENTS', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCommentPlanCon: (context, data) => {
    return Vue.http.put(`${env.API}/api/comments-plancon/${data.id}`, data)
      .then((response) => {
        context.commit('SET_COMMENT', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  cleanStorePlan: (context) => {
    context.commit('CLEAN')
    return
  },
  getCommentsByPlanLider: (context, data) => {
    let {id, type} = data

    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }

    return Vue.http.get(`${env.API}/api/comments-plancon/get-comments/${id}/type/${type}${query}`)
      .then((response) => {
        context.commit('SET_COMMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        console.log(error)
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getComments: (state) => state.comments
}

export const comments_plancon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/comments_plancon.js